import { Directive, Input, OnChanges, SimpleChanges, TemplateRef, ViewContainerRef, effect, inject } from '@angular/core';
import { FeatureFlagService } from './feature-flag.service';

@Directive({
  selector: '[appFeatureFlag]',
  standalone: true
})
export class FeatureFlagDirective implements OnChanges {

  readonly templateRef = inject(TemplateRef<unknown>)
  readonly viewContainerRef = inject(ViewContainerRef)
  readonly featureFlagFacade = inject(FeatureFlagService)

  @Input({required: true, alias: 'appFeatureFlag'}) featureFlag!: any
  @Input() featureFlagElse: TemplateRef<unknown> | null = null

  constructor() {
    effect(() => {
      if(this.featureFlag) {
        this.onChanges()
      }
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.onChanges()
  }


  onChanges() {
    this.viewContainerRef.clear()

    if(this.featureFlagEnabled()) {
      this.viewContainerRef.createEmbeddedView(this.templateRef)
    } else if(this.featureFlagElse) {
      this.viewContainerRef.createEmbeddedView(this.featureFlagElse)
    }
  }


  featureFlagEnabled() {
    if(!this.featureFlag) {
      return true
    }

      return this.featureFlagFacade.featureFlagEnabled(this.featureFlag)
  }

}